import { Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import AcessoMenu from '../../../components/acesso-menu';
import useDispatchWithResult from '../../../hooks/useDispatchWithResult';
import AuthenticatedLayout from '../../../layouts/authenticated';
import { acessoSelector, fetchAcessos } from '../../../store/acessos';
import { isClienteGestorSelector } from '../../../store/autenticacao';
import { alertasByEmpresaIdSelector, empresasFiltradasSelector, fetchEmpresas, filtradoSelector, limparEmpresas } from '../../../store/empresas';
import { empresasSelector, fetchTabela } from '../../../store/regulatorioTabela';
import EmpresaCard from './_EmpresaCard';
import PesquisaMenu from "../../../components/pesquisa-menu";
import RegulatorioMenu from "../../../components/regulatorio-menu";
import RegulatorioFiltroForm from "../filtro/_RegulatorioFiltroForm";

export default function RegulatorioDetalhadoPage() {
  const isClienteGestor = useSelector(isClienteGestorSelector);
  const acesso = useSelector(acessoSelector);
  const empresas = useSelector(empresasSelector);
  const filtrado = useSelector(filtradoSelector);
  const empresasFiltradas = useSelector(empresasFiltradasSelector);
  const alertasByEmpresaId = useSelector(alertasByEmpresaIdSelector);
  const dispatch = useDispatchWithResult();
  const acessoId = acesso?.id;

  useEffect(() => {
    dispatch(fetchAcessos({ modulo: 'regulatorio' }));
  }, []);

  useEffect(() => {
    if (acessoId || filtrado)
      dispatch(fetchEmpresas({ acessoId, modulo: 'regulatorio' }));
    else
      dispatch(limparEmpresas());
  }, [acessoId]);

  useEffect(() => {
    dispatch(fetchTabela({ empresas: empresasFiltradas, alertasByEmpresaId }));
  }, [empresasFiltradas, alertasByEmpresaId]);

  return (
    <AuthenticatedLayout
      modulo="regulatorio"
      menu={
        <>
          <AcessoMenu allowClear defaultRoute="/regulatorio/detalhado" fetchEmpresas modulo="regulatorio"/>
          {acessoId > 0 && <PesquisaMenu/>}
          <RegulatorioMenu showCreate={isClienteGestor} showFilter/>
        </>
      }
    >
      <RegulatorioFiltroForm/>
      <Row gutter={[16, 16]}>
        {empresas.map(empresa =>
          <Col key={empresa.id} span={24} md={12} lg={8} xl={6}>
            <EmpresaCard empresa={empresa}/>
          </Col>)}
      </Row>
    </AuthenticatedLayout>
  );
}
